import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { MembershipHeader } from './components';
import { actionGetMembershipPackage, actionUpdatePackageForRenew } from 'actions';
import { actionGetMemberMemberships } from 'actions';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Grid, Link, TextField, Typography, Hidden } from "@material-ui/core";
import { actionGetMemberValidation, actionResetMemberValidation, actionSetErrorMemberValidation } from 'actions';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import { actionSendEmail, actionResetSendEmail } from 'actions';
import ProcessingBox from '../Checkout/components/ProcessingBox';
import { actionGetCustomer, actionResetCustomer } from 'actions';
import ReactHtmlParser from 'react-html-parser';
import { actionGetCustomerUdfs } from 'actions';

const { TitleforloadingSendLostMemberemail, Subtitle1forloadingSendLostMemberemail, Subtitle2forloadingSendLostMemberemail, DisplayMemPackageDiscriptionCharacters,
    PhoneOrAddress1ForMemberValidate, RenewMembershipNotAllowedForNonPrimarMemberMsg, RenewMembershipIfUserHaveNoMembership } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
    }
}));

const MemberValidation = (props) => {

    const dispatch = useDispatch();
    const membershippackagesreducer = useSelector(state => state.reducerMembershipPackages);
    let membershipPackage = membershippackagesreducer.membershipPackage;
    const memberValidationReducer = useSelector(state => state.reducerMemberValidation);
    const reducerLostMember = useSelector(state => state.reducerLostMember);
    const memmemberhisps = useSelector(state => state.reducerMemberMemberships);
    const customer = useSelector(state => state.reducerCustomer);

    const [showMainValidate, setshowMainBalidate] = React.useState(false);
    const [showProgBox, setshowProgBox] = React.useState(false);
    const [showMainValidateAllFields, setshowMainValidateAllFields] = React.useState(false);

    const [errorMsg, seterrorMsg] = React.useState('');


    if (memberValidationReducer.membervalidation && memberValidationReducer.membervalidation.MemberValidation && memberValidationReducer.membervalidation.MemberValidation[0].hasOwnProperty("EmailMatched")) {

        if (!memberValidationReducer.membervalidation.MemberValidation[0].EmailMatched && memberValidationReducer.membervalidation.MemberValidation[0].PhoneMatched == undefined) {
            actionSetErrorMemberValidation(dispatch, 'Email does not match.');
            setshowMainValidateAllFields(true);
        }

        if (showMainValidateAllFields) {
            if ((memberValidationReducer.membervalidation.MemberValidation[0].PhoneMatched == undefined || memberValidationReducer.membervalidation.MemberValidation[0].PhoneMatched == false)
                && (memberValidationReducer.membervalidation.MemberValidation[0].AddressMatched == undefined || memberValidationReducer.membervalidation.MemberValidation[0].AddressMatched == false)) {
                actionSetErrorMemberValidation(dispatch, 'Phone or Address 1 does not match.');
                setshowMainValidateAllFields(true);
            }
        }
    }

    useEffect(() => {
        if (reducerLostMember.emailsend || reducerLostMember.lostmemberError.length > 0) {
            setshowProgBox(false);
        }
    }, [reducerLostMember])

    useEffect(() => {
        if (memberValidationReducer.membervalidation && memberValidationReducer.membervalidation.MemberValidation && validationfields.email && validationfields.email.trim().length > 0) {

            actionGetCustomer(dispatch, memberValidationReducer.membervalidation.MemberValidation[0].CustomerID, validationfields.email);

            // if (memberValidationReducer.loading) {
            //     actionResetMemberValidation(dispatch);
            // }
        }
    }, [memberValidationReducer.membervalidation]);

    const GetCustomersIDList = () => {
        let ids = "";

        ids += customer.customer[0].CustomerID;

        if (customer.customer[0].hasOwnProperty("LinkedIndividuals") && customer.customer[0].LinkedIndividuals.length > 0) {

            customer.customer[0].LinkedIndividuals.forEach(c => {
                ids += "," + c.CustomerID;
            });
        }

        return ids;
    }
    useEffect(() => {

        if (customer.customer && customer.customer.length > 0) {

            //Call Memberships with member ID
            if (memmemberhisps && memmemberhisps.membermerberhips) {
                actionGetMemberMemberships(dispatch, customer.customer[0].CustomerID);
                actionGetCustomerUdfs(dispatch, GetCustomersIDList());
            }
        }

        if (customer.customerError && customer.customerError.length) {
            seterrorMsg(customer.customerError);
        }

    }, [customer.customer]);

    useEffect(() => {

        if (memmemberhisps.membermerberhips && memmemberhisps.membermerberhips.length > 0 && memberValidationReducer.membervalidation &&
            memberValidationReducer.membervalidation.MemberValidation) {
            if (memmemberhisps.membermerberhips[0].Memberships && memmemberhisps.membermerberhips[0].Memberships.length > 0) {

                if (memmemberhisps.membermerberhips[0].CustomerID !== customer.customer[0].CustomerID) {
                    actionSetErrorMemberValidation(dispatch, RenewMembershipNotAllowedForNonPrimarMemberMsg);
                }
                else {

                    actionUpdatePackageForRenew(dispatch, props.match.params.id, memmemberhisps, customer.customer);

                    props.history.push({
                        pathname: '/memberships/renew/' + props.match.params.id
                    })
                }
            }

            if (!memmemberhisps.membermerberhips[0].hasOwnProperty('Memberships')) {
                actionSetErrorMemberValidation(dispatch, RenewMembershipIfUserHaveNoMembership);
            }

        }
    }, [memmemberhisps.membermerberhips]);

    const [validationfields, setvalidationfields] = React.useState({
        lastName: '',
        email: '',
        memberNo: '',
        phone: '',
        address1: ''
    });

    //Intialize States
    const [errorstate, seterrorstate] = React.useState({
        initialerrorstate: {
            last_name: {
                errorstate: false,
                errortext: ""
            },
            email: {
                errorstate: false,
                errortext: ""
            },
            member_no: {
                errorstate: false,
                errortext: ""
            },
            phone: {
                errorstate: false,
                errortext: ""
            },
            address1: {
                errorstate: false,
                errortext: ""
            }
        }
    });

    const fieldhandleChange = (event) => {

        if (event.target.name === "lname") {
            setvalidationfields({ ...validationfields, lastName: event.target.value });
        }

        if (event.target.name === "email") {
            setvalidationfields({ ...validationfields, email: event.target.value });
        }

        if (event.target.name === "memberno") {
            setvalidationfields({ ...validationfields, memberNo: event.target.value });
        }

        if (event.target.name === "phone") {
            setvalidationfields({ ...validationfields, phone: event.target.value });
        }


        if (event.target.name === "address1") {
            setvalidationfields({ ...validationfields, address1: event.target.value });
        }
    }

    useEffect(() => {
        if (props.match.path == "/memberships/membervalidate/:id") {
            actionGetMembershipPackage(dispatch, props.match.params.id);
        }
    }, []);

    const ValidateMember = () => {

        var valFields = { ...validationfields };
        var initialerrstate = { ...errorstate.initialerrorstate };


        if (valFields.lastName.trim().length < 1) {
            initialerrstate.last_name.errorstate = true;
            initialerrstate.last_name.errortext = "Last Name is required.";
            seterrorstate({ ...errorstate, initialerrstate });
        }
        else {
            initialerrstate.last_name.errorstate = false;
            initialerrstate.last_name.errortext = "";
            seterrorstate({ ...errorstate, initialerrstate });
        }


        if (showMainValidateAllFields == false) {
            if (valFields.email.trim().length < 1) {
                initialerrstate.email.errorstate = true;
                initialerrstate.email.errortext = "Email is required.";
                seterrorstate({ ...errorstate, initialerrstate });
            }
            else {
                initialerrstate.email.errorstate = false;
                initialerrstate.email.errortext = "";
                seterrorstate({ ...errorstate, initialerrstate });
            }
        }


        if (valFields.memberNo.trim().length < 1) {
            initialerrstate.member_no.errorstate = true;
            initialerrstate.member_no.errortext = "Member No is required.";
            seterrorstate({ ...errorstate, initialerrstate });
        }
        else {
            initialerrstate.member_no.errorstate = false;
            initialerrstate.member_no.errortext = "";
            seterrorstate({ ...errorstate, initialerrstate });
        }

        if (showMainValidateAllFields) {

            if (valFields.phone.trim().length < 1 && valFields.address1.trim().length < 1) {
                initialerrstate.phone.errorstate = true;
                initialerrstate.phone.errortext = "Phone No is missing.";

                initialerrstate.address1.errorstate = true;
                initialerrstate.address1.errortext = "Address 1 is missing.";

                seterrorstate({ ...errorstate, initialerrstate });
            }
            else {
                initialerrstate.phone.errorstate = false;
                initialerrstate.phone.errortext = "";
                initialerrstate.address1.errorstate = false;
                initialerrstate.address1.errortext = "";
                seterrorstate({ ...errorstate, initialerrstate });
            }


            if (valFields.lastName.trim().length > 0 && valFields.memberNo.trim().length > 0 && (valFields.phone.trim().length > 0 || valFields.address1.trim().length > 0)) {
                actionGetMemberValidation(dispatch, validationfields.memberNo, validationfields.lastName, '', validationfields.phone, validationfields.address1);
            }
        }
        else {
            if (valFields.lastName.trim().length > 0 && valFields.lastName.trim().length > 0 && valFields.memberNo.trim().length > 0) {
                actionGetMemberValidation(dispatch, validationfields.memberNo, validationfields.lastName, validationfields.email);
            }
        }
    }

    const errorcancelhandle = () => {
        actionResetMemberValidation(dispatch);

        if (customer.customerError && customer.customerError.length) {
            actionResetCustomer(dispatch);
        }

        seterrorMsg("");
    }

    const errorcancelhandleemail = () => {
        actionResetSendEmail(dispatch);
    }

    const ShowEmailView = () => {
        setshowMainBalidate(true);
        setshowMainValidateAllFields(false);
    }

    const ShowValidateView = () => {
        setshowMainBalidate(false);
        actionResetSendEmail(dispatch);

        setvalidationfields({ ...validationfields, lastName: '' });
        setvalidationfields({ ...validationfields, email: '' });
        setvalidationfields({ ...validationfields, memberNo: '' });
    }

    const SendEmailToCst = () => {

        var valFields = { ...validationfields };
        var initialerrstate = { ...errorstate.initialerrorstate };

        if (valFields.lastName.trim().length < 1) {
            initialerrstate.last_name.errorstate = true;
            initialerrstate.last_name.errortext = "Last Name is required.";
            seterrorstate({ ...errorstate, initialerrstate });
        }
        else {
            initialerrstate.last_name.errorstate = false;
            initialerrstate.last_name.errortext = "";
            seterrorstate({ ...errorstate, initialerrstate });
        }


        if (valFields.email.trim().length < 1) {
            initialerrstate.email.errorstate = true;
            initialerrstate.email.errortext = "Email is required.";
            seterrorstate({ ...errorstate, initialerrstate });
        }
        else {
            initialerrstate.email.errorstate = false;
            initialerrstate.email.errortext = "";
            seterrorstate({ ...errorstate, initialerrstate });
        }


        if (valFields.lastName.trim().length > 0 && valFields.email.trim().length > 0) {
            var request = [{
                "LastName": valFields.lastName,
                "Email": valFields.email
            }]

            setshowProgBox(true);
            actionSendEmail(dispatch, request);
        }

    }

    const [showMoreInfo, setShowMoreInfo] = React.useState(false);
    const [readmorebtnText, setreadmorebtnText] = React.useState('Read More');

    const ShowMoreInfoClick = () => {

        if (readmorebtnText === 'Read More') {
            setShowMoreInfo(true);
            setreadmorebtnText('Read Less');
        }
        else {
            setShowMoreInfo(false);
            setreadmorebtnText('Read More');
        }
    }


    const GetMembershipPackageDis = (discription) => {

        if (discription) {
            if (showMoreInfo) {
                return discription.substring(0, discription.length - 1);
            }

            return discription.substring(0, DisplayMemPackageDiscriptionCharacters);
        }

        return "";
    }

    return (

        <div style={{ width: "80%", margin: "0 auto" }} >
            <ErrorHandling msg={memberValidationReducer.membervalidationError.length > 0 ? memberValidationReducer.membervalidationError : ''}
                open={memberValidationReducer.membervalidationError.length > 0 ? true : false} handleclose={errorcancelhandle} />

            <ErrorHandling msg={reducerLostMember.lostmemberError.length > 0 ? reducerLostMember.lostmemberError : ''}
                open={reducerLostMember.lostmemberError.length > 0 ? true : false} handleclose={errorcancelhandleemail} />

            <ErrorHandling msg={errorMsg && errorMsg.length > 0 ? errorMsg : ''}
                open={errorMsg && errorMsg.length > 0 ? true : false} handleclose={errorcancelhandle} />

            <MembershipHeader membershipPackage={membershipPackage} />

            <Hidden smDown>
                <Grid xs={8} align="center" style={{ border: "0.5px solid silver", margin: "0 auto", padding: '10px' }}>
                    <Typography variant="subtitle2" color="textSecondary" style={{ padding: "20px" }} align="justify">
                        {ReactHtmlParser(GetMembershipPackageDis(membershipPackage.Description))}
                    </Typography>

                    <Link
                        component="button"
                        variant="body2"
                        disabled={membershipPackage.Description ? membershipPackage.Description.length < DisplayMemPackageDiscriptionCharacters : false}
                        onClick={ShowMoreInfoClick}
                        style={{ display: membershipPackage.Description && membershipPackage.Description.length < DisplayMemPackageDiscriptionCharacters ? 'none' : 'block' }}
                    >
                        {readmorebtnText}
                    </Link>
                </Grid>
            </Hidden>

            <Hidden lgUp>


                <Grid xs={12} align="center" style={{ border: "0.5px solid silver", margin: "0 auto", padding: '10px' }}>
                    <Typography variant="subtitle2" color="textSecondary" style={{ padding: "20px" }} align="justify">
                        {ReactHtmlParser(GetMembershipPackageDis(membershipPackage.Description))}
                    </Typography>
                    <Link
                        component="button"
                        variant="body2"
                        onClick={ShowMoreInfoClick}
                        style={{ display: membershipPackage.Description && membershipPackage.Description.length < DisplayMemPackageDiscriptionCharacters ? 'none' : 'block' }}

                    >
                        {readmorebtnText}
                    </Link>
                </Grid>
            </Hidden>



            {
                showMainValidateAllFields ?

                    <div style={{ marginTop: '20px' }}>
                        <Typography variant="subtitle2">
                            To find your existing membership, please enter following information to validate.
                        </Typography>

                        <Grid container spacing={1} style={{ marginTop: '10px' }}>
                            <Grid item lg={6} xs={12}  >
                                <TextField
                                    fullWidth
                                    autoFocus
                                    margin="dense"
                                    name="lname"
                                    id="lname"
                                    label="Last Name"
                                    type="text"
                                    required
                                    variant="outlined"
                                    onChange={fieldhandleChange}
                                    value={validationfields.lastName}
                                    error={errorstate.initialerrorstate.last_name.errorstate}
                                    helperText={errorstate.initialerrorstate.last_name.errortext}
                                />
                            </Grid>



                            <Grid item lg={6} xs={12} >
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    name="memberno"
                                    id="memberno"
                                    label="Member #"
                                    type="text"
                                    required
                                    variant="outlined"
                                    onChange={fieldhandleChange}
                                    value={validationfields.memberNo}
                                    error={errorstate.initialerrorstate.member_no.errorstate}
                                    helperText={errorstate.initialerrorstate.member_no.errortext}
                                />

                                <Link href="#" color="primary" underline="always" onClick={ShowEmailView}>
                                    I don't know my member #.
                                </Link>
                            </Grid>

                            <Grid item lg={6} xs={12}  >
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    name="phone"
                                    id="phone"
                                    label="Phone #"
                                    type="text"
                                    value={validationfields.phone}
                                    variant="outlined"
                                    onChange={fieldhandleChange}
                                    error={errorstate.initialerrorstate.phone.errorstate}
                                    helperText={errorstate.initialerrorstate.phone.errortext}
                                />
                            </Grid>



                            <Grid item lg={6} xs={12} >
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    name="address1"
                                    id="address1"
                                    label="Address 1"
                                    type="text"
                                    value={validationfields.address1}
                                    variant="outlined"
                                    onChange={fieldhandleChange}
                                    error={errorstate.initialerrorstate.address1.errorstate}
                                    helperText={errorstate.initialerrorstate.address1.errortext}
                                />
                            </Grid>

                            <Grid item lg={12} xs={12} >
                                <Typography variant="subtitle2" color="textSecondary" align="center">{PhoneOrAddress1ForMemberValidate}</Typography>
                            </Grid>
                            <Grid item lg={3} xs={12} >
                                <Hidden smDown>
                                    <Button color="primary" variant="contained" size="large" onClick={ValidateMember} style={{ marginTop: "6px" }}>
                                        Find Existing Details
                                    </Button>
                                </Hidden>

                                <Hidden lgUp>
                                    <Button color="primary" variant="contained" size="medium" onClick={ValidateMember} style={{ marginTop: "6px" }}>
                                        Find Existing Details
                                    </Button>
                                </Hidden>
                            </Grid>
                        </Grid>
                    </div>
                    :
                    <div>
                        {showMainValidate ?
                            <div style={{ marginTop: '20px' }}>

                                <Typography variant="subtitle2">
                                    Can't remember your member #? Please enter your last name + email and we'll send you an email with the member number to verify and renew.
                                </Typography>

                                <Grid container spacing={1} >
                                    <Grid item lg={4} sm={12} xs={12}  >
                                        <TextField
                                            fullWidth
                                            autoFocus
                                            margin="dense"
                                            name="lname"
                                            id="lname"
                                            label="Last Name"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.last_name.errorstate}
                                            helperText={errorstate.initialerrorstate.last_name.errortext}
                                        />
                                    </Grid>

                                    <Grid item lg={4} sm={12} xs={12}  >
                                        <TextField
                                            fullWidth
                                            margin="dense"
                                            name="email"
                                            id="email"
                                            label="Email"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.email.errorstate}
                                            helperText={errorstate.initialerrorstate.email.errortext}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} >

                                        <Hidden smDown>
                                            <Button color="primary" variant="contained" size="large" onClick={SendEmailToCst} style={{ marginTop: "7px" }}>
                                                Send Mail
                                            </Button>
                                        </Hidden>

                                        <Hidden lgUp>
                                            <Button color="primary" variant="contained" size="medium" onClick={SendEmailToCst} style={{ marginTop: "7px" }}>
                                                Send Mail
                                            </Button>
                                        </Hidden>



                                    </Grid>
                                    {!reducerLostMember.emailsend ? <Grid alignItems='center' lg={4} xs={12} style={{ minHeight: 200, marginTop: (showProgBox ? 200 : -200) }}>
                                        <ProcessingBox isshow={showProgBox} title={TitleforloadingSendLostMemberemail} text1={Subtitle1forloadingSendLostMemberemail} text2={Subtitle2forloadingSendLostMemberemail} ></ProcessingBox>
                                    </Grid>
                                        : null}

                                    {reducerLostMember.emailsend ?
                                        <div style={{ width: "100%", margin: "0 auto" }} >
                                            <Typography variant="h5" >
                                                Email sent successfully!
                                            </Typography>
                                            <Grid item lg={12} sm={12} xs={12}>
                                                <Button color="primary" variant="contained" size="large" onClick={ShowValidateView}>
                                                    Back to Renew
                                                </Button>
                                            </Grid>
                                        </div> : null}
                                </Grid>

                            </div> :
                            <div style={{ marginTop: '20px' }}>
                                <Typography variant="subtitle2">
                                    To find your existing membership, please enter following information to validate.
                                </Typography>

                                <Grid container spacing={1} >
                                    <Grid item lg={3} xs={12}  >
                                        <TextField
                                            fullWidth
                                            autoFocus
                                            margin="dense"
                                            name="lname"
                                            id="lname"
                                            label="Last Name"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.last_name.errorstate}
                                            helperText={errorstate.initialerrorstate.last_name.errortext}
                                        />
                                    </Grid>

                                    <Grid item lg={3} xs={12}  >
                                        <TextField
                                            fullWidth
                                            margin="dense"
                                            name="email"
                                            id="email"
                                            label="Email"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.email.errorstate}
                                            helperText={errorstate.initialerrorstate.email.errortext}
                                        />
                                    </Grid>

                                    <Grid item lg={3} xs={12} >
                                        <TextField
                                            fullWidth
                                            margin="dense"
                                            name="memberno"
                                            id="memberno"
                                            label="Member #"
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={fieldhandleChange}
                                            error={errorstate.initialerrorstate.member_no.errorstate}
                                            helperText={errorstate.initialerrorstate.member_no.errortext}
                                        />

                                        <Link href="#" color="primary" underline="always" onClick={ShowEmailView}>
                                            I don't know my member #.
                                        </Link>
                                    </Grid>

                                    <Grid item lg={3} xs={12} >
                                        <Button color="primary" variant="contained" size="large" onClick={ValidateMember} style={{ marginTop: "6px" }}>
                                            Find Existing Details
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        }
                    </div>
            }
        </div >
    );
};

export default MemberValidation;
